import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAndroid,
  faCss3Alt,
  faHtml5,
  faJava,
  faJs,
  faPython,
  faReact,
} from "@fortawesome/free-brands-svg-icons";
import "./skill.css";
import Fade from "react-reveal/Fade"; // Importing Zoom effect

const ImgSlider = (props) => {
  let settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
  };

  return (
    <Fade top>
        <Carousel {...settings}>
      
      <Wrap className="wrap">
        <div className="cont-course">
          <h3 className="language">
            Java
            <FontAwesomeIcon
              icon={faJava}
              size="2x"
              className="course-icon ml-2"
              color="darkorange"
            />
          </h3>
          <p className="course-info">Introduction to Programming with JAVA</p>
          <p className="course-info">Instructor - Engin Demiroğ</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">
            Constructors, Inheritance, Polymorphısm, Abstract Classes
            Constructors, Inheritance, Polymorphısm, Abstract
            Classes,Interface , Compositon, Inner Class, Static,
            Packages,Generics, Threading, JDBC, Swing
          </li>
          <p className="course-info text-muted mt-2">Progress: In progress</p>
        </div>
      </Wrap>

      <Wrap className="wrap">
        <div className="cont-course">
          <div className="kotlin">
            <h3 className="language d-inline">Kotlin</h3>
            <FontAwesomeIcon
              icon={faAndroid}
              size="3x"
              className="course-icon ml-2"
              color="#30D780"
            />
          </div>

          <p className="course-info">
            Android Mobile Application Course: Kotlin
          </p>
          <p className="course-info">Instructor - Atıl Samancıoğlu</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">
            ListView, Databases, OOP, Maps, Instagram Clone:Firebase ,
            Fragment & Navigation, Retrofit, Coroutines, WorkManager,Jetpack
            Compose StateManagement, FoursquareClone: Parse
          </li>
          <p className="course-info text-muted mt-2">Progress: In progress</p>
        </div>
      </Wrap>
      <Wrap className="wrap">
        <div className="cont-course">
          <h3 className="language">
            Python
            <FontAwesomeIcon
              icon={faPython}
              size="2x"
              className="course-icon ml-2"
              color="#356D9C"
            />
          </h3>
          <p className="course-info">
            Programming from Scratch to Advanced Python
          </p>
          <p className="course-info">Instructor - Sadık Turan</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">
            Operators, Loops, Functions, OOP, Modules , Error Management, File
            Management, Iterators, Generators,Web Scraping, Selenium, Numpy,
            Pandas,Matplotlib, MySql & SQLite,MongoDb,PyQt5,Bootstrap,Django
          </li>
          <p className="course-info text-muted mt-2">Progress: Completed</p>
        </div>
      </Wrap>
      <Wrap className="wrap">
        <div className="cont-course">
          <h3 className="language">
            Javascript
            <FontAwesomeIcon
              icon={faJs}
              size="2x"
              className="course-icon ml-2"
              color="#EFD81D"
            />
          </h3>
          <p className="course-info">
            From Zero to Advanced Modern Javascript Lessons ES7 +
          </p>
          <p className="course-info">Instructor - Sadık Turan</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">
            Dom & Events, Todo App, Slider App, Form Validator, Cinema
            TicketReservation , OOP, Quiz App, ES6 / ES7 +, Asekron & AJAX,Api
            Projects, Patterns, Module Pattern, Nodejs & Npm, Webpack
          </li>
          <p className="course-info text-muted mt-2">Progress: Completed</p>
        </div>
      </Wrap>
      <Wrap className="wrap">
        <div className="cont-course">
          <h3 className="language">
            ReactJS
            <FontAwesomeIcon
              icon={faReact}
              size="2x"
              className="course-icon ml-2"
              color="#42cff5"
            />
          </h3>
          <p className="course-info">
            From Zero to Advanced Modern Javascript Lessons ES7 +
          </p>
          <p className="course-info">Instructor - Engin Demiroğ</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">
            Components , Reactstrap, Props , State , Events , Api , Component
            Drilling, Alertifyjs , React Rounting, Redux, Redux Thunk, Error
            Management, React Hooks
          </li>
          <p className="course-info text-muted mt-2">Progress: In progress</p>
        </div>
      </Wrap>
      <Wrap className="wrap">
        <div className="cont-course">
          <h3 className="language">
            Html Css
            <FontAwesomeIcon
              icon={faHtml5}
              size="2x"
              className="course-icon ml-2"
              color="#DD4B25"
            />
            <FontAwesomeIcon
              icon={faCss3Alt}
              size="2x"
              className="course-icon ml-2"
              color="#2EA7D9"
            />
          </h3>
          <p className="course-info">Web Programming with REACT</p>
          <p className="course-info">Instructor - Engin Demiroğ</p>
          <h3 className="course-info">Topics</h3>
          <li className="course-info">HTML 5, CSS 3, Bootstrap 4</li>
          <p className="course-info text-muted mt-2">Progress: Completed</p>
        </div>
      </Wrap>
    
  </Carousel>
    </Fade>
    
  );
};

const Carousel = styled(Slider)`
  margin-top: 20px;
  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;
    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }
  ul li button {
    &:before {
      font-size: 10px;
      color: black;
    }
  }
  li.slick-active button:before {
    color: black;
    font-size:16px;
    
  }
  .slick-list {
    overflow: initial;
    height:450px;
    width:100%;
 
 }
 
  .slick-slide{
      height:100%;
    
      
,      
  }
  .slick-prev:before{
    color:black;
    font-size:30px;
    transition:0.3s;
  }
  .slick-next:before{
    color:black;
    font-size:30px;
    transition:0.3s;
  }
 
  
  .slick-prev {
    left: 0px;
  }
  .slick-next {
    right: 0px;
  }
  .slick-arrow{
    display:inline-block
    color:black;
    opacity: 0.7;
    transition: 0.4s ease-in;
  }
  .slick-arrow:hover{
    opacity: 1;
   
  }
  
`;

const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  a {
    border-radius: 4px;
    box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
      rgb(0 0 0 / 73%) 0px 16px 10px -10px;
    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;
    img {
      width: 100%;
      height: 100%;
    }
    &:hover {
      padding: 0;
      border: 4px solid rgba(249, 249, 249, 0.8);
      transition-duration: 300ms;
    }
  }
`;

export default ImgSlider;
